import React from 'react'
import {Link} from "react-router-dom"
function NavBar() {

    return (
        <div className="nav-wrapper">
            <nav className="navbar navbar-expand-md justify-content-center">
                <span  className="navbar-brand d-flex w-30"><Link to="/"><i className="fas fa-crown"> VenueFind</i></Link></span>
                <span  className="d-flex w-50 mr-auto search-form"> <span className="nav-title text-center">Find Your Venue & Discover Your Vibe</span></span>                
                <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#collapsingNavbar3">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="navbar-collapse collapse w-100" id="collapsingNavbar3">
                    <ul className="nav navbar-nav ml-auto w-100 justify-content-end">
                        <li className="nav-item">
                            <a href="#HowItWorks" className="nav-link">How it Works</a>
                        </li>
                        <li className="nav-item">
                            <a href="#Venues" className="nav-link">Venues</a>
                        </li>
                    </ul>
                </div>
            </nav>
        </div>
    )
}


export default NavBar
